import { defineMessages } from 'react-intl';

export default defineMessages({
  loading: {
    id: 'cboard.components.OAuthLogin.loading',
    defaultMessage: 'Loading...'
  },
  errorMessage: {
    id: 'cboard.components.OAuthLogin.errorMessage',
    defaultMessage: 'An error has occurred...'
  }
});
